import React, { CSSProperties, useState } from 'react';
import { Col, Row } from '../../../../lib/utils';
import dayjs from 'dayjs';
import { LEGACY_WEEKLY_BLOCK_HEIGHT } from '../layout';
import GroupSessionHoverCard from '../../GroupSessionHoverCard';

const CLASS_TYPE_COLORS: Record<string, { border: string; bg: string; text: string }> = {
    GROUP: { border: '#10B981', bg: '#ECFDF5', text: '#065F46' },
    PRIVATE_1ON2: { border: '#3B82F6', bg: '#EFF6FF', text: '#1E40AF' },
    PRIVATE_1ON3: { border: '#8B5CF6', bg: '#F5F3FF', text: '#5B21B6' },
};

const CLASS_TYPE_LABEL: Record<string, string> = {
    GROUP: '그룹',
    PRIVATE_1ON2: '1:2',
    PRIVATE_1ON3: '1:3',
};

const GroupSessionWeeklyBlock = ({ childItem, cellIndex, onClickSchedule }: any) => {
    const [isHover, setIsHover] = useState(false);
    const classType = childItem.classType || 'GROUP';
    const colorCfg = CLASS_TYPE_COLORS[classType] || CLASS_TYPE_COLORS.GROUP;
    const isOngoing = dayjs().isAfter(childItem.startTime) && dayjs().isBefore(childItem.endTime);

    // hover 카드 위치는 기존 PT 블록과 동일한 규칙 (주 후반 요일은 왼쪽으로 펼침)
    const hoverStyle: CSSProperties = cellIndex > 5 ? { right: '110%' } : { left: '110%' };

    return (
        <Col
            onClick={() => onClickSchedule(childItem)}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            style={{
                width: '95%',
                height: LEGACY_WEEKLY_BLOCK_HEIGHT,
                borderRadius: 4,
                marginBottom: 4,
                border: `1.5px solid ${colorCfg.border}`,
                backgroundColor: colorCfg.bg,
                cursor: 'pointer',
                position: 'relative',
                boxShadow: isHover ? `0 0 12px ${colorCfg.border}40` : 'none',
                transition: 'box-shadow 0.15s',
            }}
        >
            {/* 블록 본문만 잘라내고, hover 카드는 바깥에 두어 클리핑되지 않게 한다 */}
            <Col style={{ width: '100%', height: '100%', padding: '4px 7px', boxSizing: 'border-box', overflow: 'hidden' }}>
                <Row
                    style={{
                        alignItems: 'center',
                        gap: 4,
                        justifyContent: 'space-between',
                        height: 17,
                    }}
                >
                    <span
                        style={{
                            fontSize: 13,
                            fontWeight: 700,
                            color: colorCfg.text,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                        }}
                    >
                        {childItem.coachName || '강사 미정'} 강사
                    </span>
                    <span
                        style={{
                            fontSize: 10,
                            fontWeight: 600,
                            padding: '1px 4px',
                            borderRadius: 3,
                            backgroundColor: `${colorCfg.border}20`,
                            color: colorCfg.text,
                            flexShrink: 0,
                        }}
                    >
                        {CLASS_TYPE_LABEL[classType]}
                    </span>
                </Row>
                <Row
                    style={{
                        alignItems: 'center',
                        minWidth: 0,
                        height: 15,
                        gap: 8,
                    }}
                >
                    <span
                        style={{
                            fontSize: 12,
                            lineHeight: '15px',
                            fontWeight: 600,
                            color: colorCfg.text,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minWidth: 0,
                            flex: 1,
                        }}
                    >
                        {childItem.title || '그룹 수업'}
                    </span>
                    <span style={{ fontSize: 11, lineHeight: '15px', color: colorCfg.text, opacity: 0.8, flexShrink: 0 }}>
                        {childItem.currentCount ?? 0}/{childItem.maxCapacity ?? '?'}명 ·{' '}
                        {dayjs(childItem.startTime).format('HH:mm')}
                    </span>
                </Row>
            </Col>
            {isOngoing && (
                <div
                    style={{
                        position: 'absolute',
                        bottom: 3,
                        right: 4,
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        backgroundColor: colorCfg.border,
                    }}
                />
            )}
            {isHover && (
                <GroupSessionHoverCard item={childItem} style={hoverStyle} accentColor={colorCfg.border} />
            )}
        </Col>
    );
};

export default GroupSessionWeeklyBlock;
